import { useState } from "react"
import { Modal } from "~/components/Modal"
import { VotingPowerGraph } from "~/components/VotingPowerGraph"
import { useVotingPowerData } from "~/hooks/useVotingPowerData"

// Sample initial voting power data
const initialVotingPowerData = [
  { epoch: 2, stakedTokens: 2 },
  { epoch: 3, stakedTokens: 2 },
  { epoch: 5, stakedTokens: 1 }
]

export const GovenModal = ({ onDismiss }: { onDismiss: () => void }) => {
  const [visible, setVisible] = useState(true)
  const {
    votingPowerData,
    clearVotingPowerData
  } = useVotingPowerData(initialVotingPowerData)
  
  // Fixed current epoch value instead of slider
  const currentEpoch = 0
  
  return (
    <Modal 
      type="modal"
      visible={visible} 
      onOutsideClick={() => setVisible(false)}
      onExitComplete={onDismiss}
      className="md:w-[680px]"
    >
     <div
        className="flex flex-col justify-center items-start relative gap-6 px-10 pt-14 pb-10"
        style={{ boxShadow: "0px 1px 10px 0 rgba(0,0,0,0.2)" }}
      >
        <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-6">
          <div className="flex flex-col justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-4">
            <p className="flex-grow-0 flex-shrink-0 w-full text-xl text-center text-white">
              <span className="flex-grow-0 flex-shrink-0 text-xl font-semibold text-center text-white">
                Manage Voting Power
              </span>
            </p>
          </div>
          
          {/* Voting Power Graph */}
          <div className="w-full flex justify-center">
            <VotingPowerGraph 
              votingPowerData={votingPowerData} 
              width={600} 
              height={400} 
              currentEpoch={currentEpoch}
            />
          </div>
        </div>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-6 h-6 absolute right-6 top-6 cursor-pointer"
          preserveAspectRatio="none"
          onClick={() => setVisible(false)}
        >
          <path
            d="M16.2426 7.75735L7.75736 16.2426M16.2426 16.2426L7.75736 7.75735"
            stroke="white"
            strokeWidth={2}
            strokeLinecap="round"
          />
        </svg>
      </div>
    </Modal>
  )
}
